import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarTearOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCalendarTearOff"><Path d="M20.5 4.5H3.5V20.5H20.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 4.5V2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.03125 7.5L7.75 8.55882L10.9375 7.5L13.5938 8.55882L14.6562 7.5L18.375 8.02941L20.249 7.56252" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCalendarTearOff;
